import './bootstrap';

import './capture';
import './ean-print';
import './office';
import './modal';
import './scaninfo';
import './barcode-scanner';

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
